import { addDoc, collection, doc, getDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { VscArrowLeft } from "react-icons/vsc";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../css/AddNewIngredients.css";
import { db } from '../firebase-config';

const AddNewIngredient = ({ onSubmit }) => {
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [measurement, setMeasurement] = useState('');
  const [dealerPrice, setDealerPrice] = useState('');
  const [sellerPrice, setSellerPrice] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {

      const existingIngredientRef = doc(db, 'ingredients', name.toLowerCase());
      const existingIngredientSnapshot = await getDoc(existingIngredientRef);

      if (existingIngredientSnapshot.exists()) {
        throw new Error(`Ingredient "${name}" already exists.`);
      }

      const newIngredient = {
        name,
        quantity: parseFloat(quantity),
        measurement,
        dealerPrice: parseFloat(dealerPrice),
        sellerPrice: parseFloat(sellerPrice),
        createdAt: new Date().toISOString(),
      };

      await addDoc(collection(db, 'ingredients'), newIngredient);
      
      if (typeof onSubmit === 'function') {
        onSubmit(newIngredient);
      } else {
        console.warn('onSubmit prop is not a function');
      }
      
      setName('');
      setQuantity('');
      setMeasurement('');
      setDealerPrice('');
      setSellerPrice('');
      
      console.log('Ingredient added successfully');

      toast.success("Ingredient successfully added", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });

      navigate('/pages/InventoryIngredients');
    } catch (err) {
      console.error('Error adding ingredient:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setName('');
    setQuantity('');
    setMeasurement('');
    setDealerPrice('');
    setSellerPrice('');
    
    navigate('/pages/InventoryIngredients');
  };

   return (
    <div className="container mt-5">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
        <div className="close-button" onClick={handleCancel}>
        <VscArrowLeft />
        </div>
        <h1 className="mb-4">Add New Ingredient</h1>
          <label htmlFor="ingredientName" className="form-label">Name</label>
          <input
            type="text"
            id="ingredientName"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter ingredient name"
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="ingredientQuantity" className="form-label">Quantity</label>
          <input
            type="number"
            id="ingredientQuantity"
            className="form-control"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Enter quantity"
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="ingredientName" className="form-label">Unit of Measurement</label>
          <input
            type="text"
            id="unitOfMeasurement"
            className="form-control"
            value={measurement}
            onChange={(e) => setMeasurement(e.target.value)}
            placeholder="Enter unit of measurement"
            required
          />
          </div>

        <div className="mb-3">
          <label htmlFor="dealerPrice" className="form-label">Dealer's Price</label>
          <input
            type="number"
            id="dealerPrice"
            className="form-control"
            value={dealerPrice}
            onChange={(e) => setDealerPrice(e.target.value)}
            placeholder="Enter dealer's price"
            required
          />
        </div>


        <div className="mb-3">
          <label htmlFor="sellerPrice" className="form-label">Seller's Price</label>
          <input
            type="number"
            id="sellerPrice"
            className="form-control"
            value={sellerPrice}
            onChange={(e) => setSellerPrice(e.target.value)}
            placeholder="Enter seller's price"
            required
          />
        </div>
        
        <button type="submit" className="button-add-new-ingredient" disabled={isLoading}>
          {isLoading ? 'Adding...' : 'Add Ingredient'}
        </button>
      </form>
    </div>
  );
};

export default AddNewIngredient;
